export default "/images/430257f711c3127dd9e363e5f8610995.avif";